// src/components/TransactionUploader/rowReducer.ts
import { RowState, Action } from './types';

export function rowReducer(state: RowState[], action: Action): RowState[] {
  switch (action.type) {
    case 'INIT_ROWS':
      // Create one RowState per transaction, reset everything else
      return action.payload.map(tx => ({
        tx, analysis: undefined,
        deeper: undefined,
        versamenti: undefined,
        error: undefined,
        processing: false,
      }));

    case 'SET_ANALYSIS':
      return state.map((row, i) =>
        i === action.index ? { ...row, analysis: action.payload, error: undefined } : row
      );

    case 'SET_DEEPER':
      return state.map((row, i) =>
        i === action.index ? { ...row, deeper: action.payload } : row
      );

    case 'SET_VERSAMENTI':
      return state.map((row, i) =>
        i === action.index ? { ...row, versamenti: action.payload } : row
      );

    case 'SET_ERROR':
      return state.map((row, i) =>
        i === action.index ? { ...row, error: action.payload } : row
      );

    case 'SET_PROCESSING':
      return state.map((row, i) =>
        i === action.index ? { ...row, processing: action.payload } : row
      );

    case 'CLEAR_ERROR': {
      return state.map((row, i) =>
        i === action.index
          ? { ...row, error: undefined }
          : row
      );
    }


    default:
      return state;
  }
}
